import { Col, Row } from "antd";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { TiArrowBack } from "react-icons/ti";
import { BiMessageRounded } from "react-icons/bi";
import { useEffect } from "react";
import { messages } from "../../../../data/messages";
import TextArea from "antd/es/input/TextArea";

import "./MessageDetails.css";

function MessageDetails() {
  const [messageDetails, setMessageDetails] = useState(messages);
  const [message, setMessage] = useState("");
  const [sentMessages, setSentMessages] = useState([]);

  const { id } = useParams();

  let today = new Date();

  let date =
    today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear();
  let time = today.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

  const navigate = useNavigate();

  useEffect(() => {
    const filteredMessageDetails = messages.find((item) => {
      return item.id === Number(id);
    });

    setMessageDetails(filteredMessageDetails);
  }, []);

  const sendMessage = () => {
    if (message !== "") {
      setSentMessages([
        ...sentMessages,
        { message: message, date: date, time: time },
      ]);
    }
    setMessage("");
  };

  return (
    <Row className="message-details" gutter={[0, 16]}>
      <Col span={24}>
        <div
          className="back-container"
          onClick={() => navigate("/communication/messages")}
        >
          <TiArrowBack size={20} />
          <span>All messages</span>
        </div>
      </Col>
      <Col span={24}>
        <span className="contact">{messageDetails.contact}</span>
      </Col>
      <Col span={24} className="message-container">
        <div className="recieved-message-container">
          <span className="message">{messageDetails.message}</span>
          <span className="date silver-text">
            Recieved on {messageDetails.date} at {messageDetails.time}
          </span>
        </div>
        {sentMessages.map((message, index) => {
          return (
            <div className="sent-message-container" key={index}>
              <span className="message active-user">{message.message}</span>
              <span className="date silver-text">
                Sent on {message.date} at {message.time}
              </span>
            </div>
          );
        }, [])}
      </Col>
      <Col span={24}>
        <TextArea
          rows={3}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </Col>
      <Col span={24}>
        <button onClick={() => sendMessage()} className="send-button">
          <BiMessageRounded size={18} /> <span>Send</span>
        </button>
      </Col>
    </Row>
  );
}

export default MessageDetails;
